export const CASE_BASIC_INFO_TAB = {
  BASIC_FORM: 1,
  JOB_INFO: 2,
  REQUEST: 3,
};

export const CASE_BASIC_INFO_TAB_LABEL = {
  [CASE_BASIC_INFO_TAB.BASIC_FORM]: "案件情報",
  [CASE_BASIC_INFO_TAB.JOB_INFO]: "求人情報",
  [CASE_BASIC_INFO_TAB.REQUEST]: "応募要件",
};
